// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__20TmR","containerItemsCenter":"Skeleton_containerItemsCenter__150ZH"};